module.exports = __webpack_public_path__ + "static/media/omnia-crystalline-big.6608476d.png";